<template>
    <div class="icon-addon addon-lg">
        <input type="text" v-bind:placeholder="placeholder" class="form-control" v-bind:id="SearchId">
        <label for="search" class="fa fa-search" rel="tooltip" title="search"></label>
    </div>
</template>

<script>
var autocomplete = null;
export default {
    name: "AddressSearch",
    props: ["placeholder", "SearchId"],
    mounted() {
        this.initAutocomplete();
    },
    methods: {
        initAutocomplete() {
            var elementId = this.SearchId
            var search = document.getElementById(elementId);
            var paramerter = { types: ['geocode'] };
            this.autocomplete = new google.maps.places.Autocomplete(search, paramerter);
            this.autocomplete.addListener('place_changed', this.fillInAddress);
        },
        fillInAddress() {
            var place = this.autocomplete.getPlace();
            this.$emit('AddressChanged', place);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ClientPracticeAddressSearch.vue